export default class ChannelNotAccessibleError extends Error {
  constructor(message = 'Channel is not accessible!') {
    super(message);
    this.name = 'ChannelNotAccessibleError';
  }
}
